import { Modal } from "antd";
import React from "react";
import Typography from "../helpers/fonts";
import { applyDimensionChanges } from "../viewer/viewerActions";
import { useUiState } from "../state/ui-state/ui-state";
import { useTranslation } from "react-i18next";
import { useViewerState } from "../state/viewer-state/viewer-state";
import { Option } from "@swd_admin/cdc-viewer";
import { useAppState } from "../state/appstate/appstate";

export const ChangeDimensionModal: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const {
    styleProduct: { style },
  } = useAppState();
  const { setRemovableInstanceIds, removableInstanceIds } = useUiState();
  const { viewerState } = useViewerState();
  const allOptions: Option[] = [...style?.features || [], ...style?.options || []];

  return (
    <Modal
      visible={!!removableInstanceIds?.length}
      title={
        <Typography styleid={8}>{t("sizeChangeConfirmation.title")}</Typography>
      }
      onCancel={() => {
        const current = {
          ...useAppState.getState().uState?.dimensions,
          overhang: useAppState.getState().uState?.overhang,
          openAreaSize: useAppState.getState().uState?.openAreaSize,
        };
        do {
          useAppState.revert();
        } while (
          JSON.stringify(current) ===
          JSON.stringify({
            ...useAppState.getState().uState?.dimensions,
            overhang: useAppState.getState().uState?.overhang,
            openAreaSize: useAppState.getState().uState?.openAreaSize,
          })
        )
        setRemovableInstanceIds(undefined);
      }}
      onOk={() => applyDimensionChanges()}
      okText={t("sizeChangeConfirmation.yes")}
      cancelText={t("sizeChangeConfirmation.no")}
    >
      <p>
        {t("sizeChangeConfirmation.text", {
          options:
            viewerState?.style?.instances
              ?.filter(({ id }) => removableInstanceIds?.includes(id))
              .map(
                ({ optionId }) =>
                  allOptions.find(({ orderCode }) => orderCode === optionId)
                    ?.title
              )
              ?.join(', ') || "",
        })}
      </p>
    </Modal>
  );
};
